var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 139,
    viewBox: "0 0 291 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.655 128.714L222.678 129.077L223.025 129.19C225.84 130.104 233.269 132.509 236.161 133.354L236.163 133.355C237.323 133.688 238.027 134.515 238.231 135.372C238.432 136.215 238.161 137.117 237.295 137.709C236.379 138.239 235.33 138.499 234.272 138.459L234.262 138.459H234.251H215.522C214.024 138.459 212.927 138.227 212.213 137.713C211.538 137.228 211.111 136.419 211.116 135.004L211.116 134.983L211.114 134.963L210.428 125.504H222.448L222.655 128.714Z",
    fill: "#082C4E",
    stroke: "#082C4E",
    strokeWidth: 1.0735
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.384 73.829L201.021 73.8484L200.904 74.1935C199.959 76.9977 197.479 84.4012 196.612 87.2712L196.611 87.2743C196.274 88.4162 195.444 89.1145 194.582 89.3149C193.737 89.5116 192.838 89.2388 192.256 88.3726C191.739 87.4492 191.492 86.3988 191.543 85.3416L191.544 85.3313L191.544 85.321L191.742 66.6025L191.742 66.6025V66.5968C191.742 65.1041 191.985 64.0121 192.508 63.3049C193.004 62.635 193.824 62.2163 195.235 62.2355L195.254 62.2358L195.273 62.2347L205.665 61.6376L204.061 73.6863L201.384 73.829Z",
    fill: "#082C4E",
    stroke: "#082C4E",
    strokeWidth: 1.0735
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.224 47.7963C241.265 47.4843 258.673 44.5517 258.673 44.5517C251.546 25.5109 244.074 9.26734 242.222 3.07983C242.222 3.07983 237.248 95.7677 236.926 118.323C236.874 121.599 234.689 125.01 231.421 125.01H204.7C203.845 125.009 203 124.825 202.222 124.471C201.444 124.117 200.751 123.6 200.189 122.956C199.627 122.312 199.21 121.555 198.965 120.736C198.72 119.917 198.653 119.056 198.769 118.209C205.023 72.6711 209.809 28.6202 215.699 1",
    stroke: "#082C4E",
    strokeWidth: 0.751449,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273.263 9.81934C279.344 24.5548 284.658 39.5948 289.183 54.879C290.65 60.0058 289.652 66.786 281.587 68.6371L238.509 77.1332",
    stroke: "#082C4E",
    strokeWidth: 0.751449,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2146 129.878L98.3027 130.038L110.112 133.874L109.963 134.307C109.963 134.307 109.963 134.307 109.963 134.307C111.099 134.701 111.735 135.437 111.938 136.152C112.135 136.849 111.938 137.568 111.319 138.062C110.566 138.452 109.715 138.609 108.872 138.515L108.847 138.512H108.822H93.187C91.9472 138.512 91.2619 138.326 90.7479 137.916C90.2129 137.489 89.7945 136.77 89.2286 135.509L86.1917 126.584H96.3954L98.2146 129.878Z",
    fill: "#082C4E",
    stroke: "#082C4E",
    strokeWidth: 0.915054
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1008 134.169L10.1034 134.16L10.1055 134.15L11.7278 126.942H22.9813L24.2379 134.808L24.2377 134.808L24.2399 134.82C24.4872 136.143 24.1543 137.039 23.5458 137.614C22.9167 138.209 21.9188 138.532 20.7169 138.532H12.1856C11.1979 138.532 10.5718 137.958 10.2282 137.098C9.87617 136.216 9.85305 135.084 10.1008 134.169Z",
    fill: "#082C4E",
    stroke: "#082C4E",
    strokeWidth: 0.915054
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5415 16.7071C49.5415 16.7071 52.5714 22.0221 56.2878 34.3079C61.9815 53.0979 70.0185 85.9027 77.2042 122.879C77.3611 123.791 77.834 124.619 78.5403 125.218C79.2465 125.817 80.141 126.148 81.0671 126.154H102.395C102.965 126.155 103.528 126.03 104.045 125.79C104.561 125.55 105.019 125.199 105.386 124.763C105.752 124.327 106.019 123.816 106.166 123.266C106.314 122.716 106.339 122.141 106.24 121.58C103.192 104.784 93.2783 43.7486 73.0759 1",
    stroke: "#082C4E",
    strokeWidth: 0.658839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8191 1.30176C22.0248 19.3416 2.2709 102.771 1.00768 122.147C0.973937 122.689 1.05164 123.233 1.23601 123.744C1.42038 124.255 1.70751 124.723 2.0797 125.119C2.45189 125.514 2.90126 125.83 3.40014 126.046C3.89901 126.262 4.43681 126.373 4.98042 126.373H30.0343C32.277 126.373 33.6958 124.544 34.0162 122.284C36.7623 103.659 48.5249 38.708 51.9576 21.958",
    stroke: "#082C4E",
    strokeWidth: 0.658839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegs1);
export default __webpack_public_path__ + "static/media/legs1.63de69b17c7eeb0a044751bd0d0f3a9d.svg";
export { ForwardRef as ReactComponent };